import $ from 'jquery';
import { createFeaturePreference } from '~graphql/controllers';
import { redirectToGiottoV2 } from '~src/utils/redirectToGiottoV2';

/**
 * Levels:
 *  - primary
 *  - secondary
 *  - success
 *  - danger
 *  - warning
 *  - info
 *  - light
 *  - dark
 */
export const addAnnouncement = ({
  id = 'announcement-default',
  level = 'info',
  title = '',
  message = '',
}) => {
  if (!title && !message) {
    throw new Error('Cannot addAnnouncement: Empty title and message');
  }

  const alreadyExists = $(`#${id}`).length > 0;

  if (alreadyExists) {
    return;
  }

  let announcementHtml = `<div id="${id}" class="alert alert-${level}" role="alert">`;

  if (title) {
    announcementHtml += `<p class="lead font-bold"><strong>${title}</strong></p>`;
  }

  if (message) {
    announcementHtml += `<p class="lead">${message}</p>`;
  }

  announcementHtml += '</div>';

  $('.layout-announcements').append(announcementHtml);
};

export const addAdminLoginAnnouncement = () => {
  const params = {
    id: 'announcement-admin-top',
    title: 'Da grandi poteri derivano grandi responsabilità',
    message:
      'Sei loggato come Global Editor. Ogni modifica può avere un impatto su tutti gli utenti, mi raccomando, fai attenzione!',
    level: 'warning',
  };
  addAnnouncement(params);
};

/**
 * Giotto 2.0 Beta announcement
 * Shown to users in the giotto.v2_beta_group feature flag
 */
export const addGiottoV2BetaAnnouncement = () => {
  const id = 'announcement-giotto-v2-beta';
  // Only show on large screens and above (Bootstrap lg >= 992px)
  if (!window.matchMedia('(min-width: 992px)').matches) {
    return;
  }
  const alreadyExists = $(`#${id}`).length > 0;
  if (alreadyExists) return;

  const title = 'Prova il nuovo Giotto 2.0 (Beta)';
  const message =
    "Stiamo lavorando alla prossima versione dell'editor Giotto. Sei stato selezionato per provarla in anteprima.";

  let html = `<div id="${id}" class="giotto-v2-banner alert" role="alert">`;
  html += '<div class="v2-content">';
  html += '  <div class="v2-copy">';
  html += `    <div class="v2-title">${title}</div>`;
  html += `    <p class="v2-subtitle">${message}</p>`;
  html += '  </div>';
  html += '  <div class="v2-actions">';
  html +=
    '    <button id="giotto-v2-beta-cta" type="button" class="btn v2-cta-btn">Partecipa alla Beta</button>';
  html += '  </div>';
  html += '</div>'; // v2-content
  html += '</div>'; // giotto-v2-banner

  // Prepend to show this promo first, above other announcements
  $('.layout-announcements').prepend(html);

  // Bind CTA click handler (delegated for robustness)
  $('body')
    .off('click', '#giotto-v2-beta-cta')
    .on('click', '#giotto-v2-beta-cta', async function () {
      const $btn = $(this);
      $btn.prop('disabled', true).text('Attendere...');
      try {
        await createFeaturePreference({
          key: 'giotto.use_v2',
          disabled: false,
          product: 'giotto',
        });
        // Redirect to Giotto 2.0 immediately after enabling the flag
        redirectToGiottoV2();
      } catch (e) {
        $btn.prop('disabled', false).text('Partecipa alla Beta');
      }
    });
};
